import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import { Field } from 'formik';
import { QUESTIONS } from '../constants';
import { ORGANIZATION_ROLE_OPTIONS } from '../../../constants';
import FormikAutocomplete from '../../FormikAutocomplete';

const DoctorSelectionField = ({ name, doctors }) => {
  const sortedDoctos = useMemo(() => {
    if (Array.isArray(doctors)) {
      return [...doctors].sort((a, b) => (a.full_name > b.full_name ? 1 : -1));
    }
    return [];
  }, [doctors]);

  const [items, setItems] = useState(sortedDoctos.map(doctor => doctor.id));

  const getLabel = doctor => {
    return `${doctor.full_name} ${
      ORGANIZATION_ROLE_OPTIONS[doctor.role]
        ? `(${ORGANIZATION_ROLE_OPTIONS[doctor.role].shortLabel})`
        : ''
    }`;
  };

  const handleOnChangeSearchQuery = value => {
    const lowerCaseValue = value.toLowerCase();
    const valueIsSelected = value && !!sortedDoctos.find(doctor => getLabel(doctor) === value);
    if (valueIsSelected) {
      setItems(sortedDoctos.map(doctor => doctor.id));
    } else {
      const newItems = sortedDoctos.filter(
        doctor =>
          doctor.full_name.toLowerCase().indexOf(lowerCaseValue) !== -1 ||
          (ORGANIZATION_ROLE_OPTIONS[doctor.role] &&
            ORGANIZATION_ROLE_OPTIONS[doctor.role].shortLabel
              .toLowerCase()
              .indexOf(lowerCaseValue) !== -1)
      );
      setItems(newItems.map(doctor => doctor.id));
    }
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <Field
        options={items}
        getOptionLabel={option => {
          if (option) {
            const doctor = doctors.find(doc => doc.id === option);
            return doctor ? getLabel(doctor) : '';
          }
          return '';
        }}
        autoComplete
        getOptionSelected={(option, value) => {
          if (!value) {
            return null;
          }
          return option.id === value;
        }}
        textFieldProps={{
          label: QUESTIONS[name],
          variant: 'outlined',
          fullWidth: true,
          required: true
        }}
        name={name}
        onInputChange={(event, newInputValue) => handleOnChangeSearchQuery(newInputValue)}
        component={FormikAutocomplete}
      />
    </FormControl>
  );
};

DoctorSelectionField.propTypes = {
  name: PropTypes.string.isRequired,
  doctors: PropTypes.arrayOf(
    PropTypes.shape({
      role: PropTypes.string.isRequired,
      full_name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    })
  ).isRequired
};

export default DoctorSelectionField;
